import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './styles/shared.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Footer from './components/Footer';
import CTASection from './components/CTASection';
import Product from './pages/Product';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EventsPage from './pages/Events';
import TasksPage from './pages/Tasks';
import CalendarPage from './pages/Calendar';
import SignUp from './pages/SignUp';
import SharedView from './pages/SharedView';
import QuizPage from './pages/QuizPage';
import PlayBookPage from './pages/PlayBook';
import BudgetPage from './pages/Budget';
import ForecastPage from './pages/Forecast';
import ProjectOverviewPage from './pages/ProjectOverview';
import Settings from './pages/Settings';

function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <CTASection />
    </>
  );
}

const dashboardPaths = ['/dashboard', '/events', '/tasks', '/calendar', '/settings', '/playbook', '/project-overview'];

function AppContent() {
  const location = useLocation();
  const isDashboardArea = dashboardPaths.some(path => location.pathname.startsWith(path));
  // Shared views are for people without a Zibit account: no marketing nav
  // or footer, just the content that was shared with them.
  const isSharedView = location.pathname.startsWith('/shared');

  return (
    <div className="App">
      {!isDashboardArea && !isSharedView && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product" element={<Product />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/blog" element={<Resources />} />
        <Route path="/resources/faq" element={<Resources />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/budget" element={<BudgetPage />} />
        <Route path="/events/forecast" element={<ForecastPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/QuizPage" element={<QuizPage />} />
        <Route path="/playbook" element={<PlayBookPage />} />
        <Route path="/project-overview" element={<ProjectOverviewPage />} />
        <Route path="/shared/:token" element={<SharedView />} />
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
      {!isDashboardArea && !isSharedView && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
